import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { clearBuffer } from '../../actions/buffer';

const initialState = null as PaymentGatewayConfig | null;

const slice = createSlice({
  name: '$bufferPaymentGatewayConfig',
  initialState,
  reducers: {
    setBufferPaymentGatewayConfig(
      state,
      action: PayloadAction<PaymentGatewayConfig | null>,
    ) {
      return action.payload;
    },
  },
  extraReducers: builder => {
    builder.addCase(clearBuffer, (_state, _action) => {
      return initialState;
    });
  },
});

export const { setBufferPaymentGatewayConfig } = slice.actions;
export default slice.reducer;
